import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect, useDispatch } from "react-redux"
import withRouter from "../../components/Common/withRouter"

import { logoutUser } from "../../store/actions"
import { removeLocalItem } from "../../utils/storage"
import { useNavigate } from "react-router-dom"

const Logout = () => {
  document.title = " Logout | Minible - Responsive Bootstrap 5 Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    // Remove per-user local items (namespaced) introduced by the app. Compute
    // and remove these before clearing the auth token so the namespacing can
    // resolve the current user's key correctly.
    try { removeLocalItem("comparisonBetween") } catch (err) { /* noop */ }
    try { removeLocalItem("trackedApps") } catch (err) { /* noop */ }

    // Remove auth tokens and other persistent values
    localStorage.removeItem("authToken")
    localStorage.removeItem("authUser")
    // Don't clear remember me data - it should persist across sessions
    // localStorage.removeItem("rememberMe")
    // localStorage.removeItem("userEmail")

    // Clear session-scoped storage (already namespaced by session helpers)
    sessionStorage.clear()

    dispatch(logoutUser(history))
  }, [dispatch, history])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func,
}

export default withRouter(connect(null, { logoutUser })(Logout))
